module.exports = __webpack_public_path__ + "media/andenes/sello_anden-dfe7abac.webp";